import script from "./ColoredLabels.vue?vue&type=script&setup=true&lang=js"
export * from "./ColoredLabels.vue?vue&type=script&setup=true&lang=js"

import "./ColoredLabels.vue?vue&type=style&index=0&id=286796ca&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-286796ca"]])

export default __exports__